const Rating = () => {
    return(
        <h1>Rating</h1>
    );
}

export default Rating;